// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__e0VPt","header":"Layout_header__UTT6r","main":"Layout_main__PJ-ey","footer":"Layout_footer__Hpk5x","disable":"Layout_disable__nb+mf"};